import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import useWindowDimensions from "../../utils/useWindowDimensions";
import { useLocationDetails } from "../../hooks/useLocationDetails";

import { sectionListSelector } from "../../reducers/sectionManagement/selectors";
import { onSectionClick } from "../../reducers/ownApp/thunkActions";

import { SectionSortBar } from "./SectionSortBar";
import SectionList from "./SectionList";
import SectionViews from "./SectionViews";
import { View } from "../Base";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const SectionDetail = memo(() => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const sections = useSelector(sectionListSelector);
  const { height: windowHeight } = useWindowDimensions();
  const { params, removeParam } = useLocationDetails();

  useEffect(() => {
    if (sections.length && params.sectionCode) {
      sections.find(({ sectionCode }) => sectionCode === +params.sectionCode) &&
        dispatch(onSectionClick({ sectionCode: +params.sectionCode }));
      removeParam("sectionCode");
    }
  }, [dispatch, sections, params.sectionCode, removeParam]);

  return (
    <div className={styles.container}>
      <SectionViews />
      <SectionSortBar />
      <View className={styles.list}>
        <SectionList sections={sections} height={windowHeight - 254} />
      </View>
    </div>
  );
});

export default SectionDetail;
